import { PartiResultat } from '../../../domain'

export const deletall = [
  0,
  1.4,
  ...Array(100)
    .fill(0)
    .map((_, idx) => 2 * idx + 1)
    .slice(1)
]

export function calculateStemmerForTapeSisteMandat(
  sisteParti: PartiResultat,
  nesteParti: PartiResultat,
  brukListestemmer: boolean,
  antallMandater: number
) {
  if (
    !sisteParti.mandater ||
    !sisteParti.mandater.sisteMandat ||
    !nesteParti.mandater ||
    typeof sisteParti.mandater.antall === 'undefined'
  ) {
    throw new Error('Parti mangler mandatinfo')
  }

  const sisteKvotient = sisteParti.mandater.sisteMandat.kvotient
  const nesteKvotient = nesteParti.mandater.nesteMandat.kvotient
  const differanse = sisteKvotient - nesteKvotient
  const antallStemmer = differanse * deletall[sisteParti.mandater.antall]

  if (brukListestemmer) {
    return Math.round(antallStemmer / antallMandater)
  } else {
    return Math.round(antallStemmer)
  }
}

export function calculateStemmerForVinneNesteMandat(
  sisteParti: PartiResultat,
  nesteParti: PartiResultat,
  brukListestemmer,
  antallMandater
) {
  if (
    !sisteParti.mandater ||
    !sisteParti.mandater.sisteMandat ||
    !nesteParti.mandater ||
    typeof nesteParti.mandater.antall === 'undefined'
  ) {
    throw new Error('Parti mangler mandatinfo')
  }

  const differanse =
    sisteParti.mandater.sisteMandat.kvotient - nesteParti.mandater.nesteMandat.kvotient
  const antallStemmer = differanse * deletall[nesteParti.mandater.antall + 1]

  if (brukListestemmer) {
    return Math.round(antallStemmer / antallMandater)
  } else {
    return Math.round(antallStemmer)
  }
}

export function validateListestemmer(sisteParti: PartiResultat, brukListestemmer) {
  if (
    !sisteParti.mandater ||
    !sisteParti.mandater.sisteMandat ||
    !sisteParti.mandater.antall ||
    !sisteParti.stemmer.antall
  ) {
    throw new Error(`Parti ${sisteParti.parti.id} mangler mandatinfo`)
  }

  const antallStemmer = Math.round(
    sisteParti.mandater.sisteMandat.kvotient * deletall[sisteParti.mandater.antall]
  )

  if (brukListestemmer) {
    if (antallStemmer > sisteParti.stemmer.antall.total) {
      return { valid: true }
    } else {
      return {
        valid: false,
        error: `Bruker listestemmer, men kvotienten ser ikke ut til å være basert på listestemmer. \n Kvotient: ${sisteParti.mandater.sisteMandat.kvotient} \n Kalkulerte stemmer: ${antallStemmer} \n Partistemmer: ${sisteParti.stemmer.antall.total}`
      }
    }
  } else {
    if (
      antallStemmer > sisteParti.stemmer.antall.total - 1 &&
      antallStemmer < sisteParti.stemmer.antall.total + 1
    ) {
      return { valid: true }
    } else {
      return {
        valid: false,
        error: `Bruker ikke listestemmer, men kvotienten ser ikke ut til å være basert på stemmer. Kvotient: ${sisteParti.mandater.sisteMandat.kvotient} Kalkulerte stemmer: ${antallStemmer} Partistemmer: ${sisteParti.stemmer.antall.total}`
      }
    }
  }
}

export function hasSisteMandat(mandater) {
  return partiresultat =>
    partiresultat.mandater &&
    partiresultat.mandater.sisteMandat &&
    partiresultat.mandater.sisteMandat.mandatrang === mandater.antall
}

export function hasNesteMandat(mandater) {
  return partiresultat =>
    partiresultat.mandater &&
    partiresultat.mandater.nesteMandat &&
    partiresultat.mandater.nesteMandat.mandatrang === mandater.antall + 1
}

const TERSKEL_UTRYGG_AV_GJENVARENDE = 0.02 // Dersom 2% av gjenværende stemmer fører til bytte av mandat regnes det som utrygt
const TERSKEL_UTRYGG_AV_OPPTALTE = 0.0025 // Dersom 0.5% av totale stemmer fører til bytte av mandat regnes det som utrygt

export function isTrygg(
  stemmeberettigede: number,
  frammoteProsent: number,
  totalStemmer: number,
  endringStemmer: number
) {
  const antallFremmotte = (frammoteProsent * stemmeberettigede) / 100

  const remainingStemmer = Math.max(antallFremmotte - totalStemmer, 1)

  const prosentAvGjenvarende = endringStemmer / remainingStemmer
  const prosentAvOpptalte = endringStemmer / totalStemmer

  return (
    prosentAvGjenvarende > TERSKEL_UTRYGG_AV_GJENVARENDE &&
    prosentAvOpptalte > TERSKEL_UTRYGG_AV_OPPTALTE
  )
}
